import gql from 'graphql-tag';

export const WS_SERVICE_CONFIG_UPDATE = gql`
  subscription($serviceIds: [Int!]!) {
    serviceConfigUpdate (serviceIds: $serviceIds) {
      serviceId
      config {
        subjectsEnabled
        subjectsRequired
        fileUploadsEnabled
        summaryEnabled
        summaryRequired
        prescriptionsEnabled
        customerAvailabilityEnabled
        providerAvailabilityEnabled
        queueEnforcementType
        queueType
        forceCloseAppointmentEnabled
        providerSelectionType
        selfServiceEnabled
        schedulingType
        fixedAppointmentDuration
        defaultAppointmentDuration
        maxAppointmentDuration
        overlappingSchedules
      }
    }
  }
`;
